module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-image-1-533x800-128b160f5b0c9f41d370539449b30ec1.jpg";